import React from 'react';
import PropTypes from 'prop-types';

const AmenitiesList = props => {
    const columnWrapper = {};
    const result = [];

    for (let i = 0; i < props.columns; i++) {
        columnWrapper[`column${i}`] = [];
    }

    for (let i = 0; i < props.children.length; i++) {
        const columnIndex = i % props.columns;
        columnWrapper[`column${columnIndex}`].push(
          <div style={{ marginBottom: `${props.gap}px`, width:'100%'}}>
            {props.children[i]}
          </div>
        );
    }

    for (let i = 0; i < props.columns; i++) {
        result.push(
          <div style={{width: '25%', display: 'flex', flexDirection: 'column'}}>
            {columnWrapper[`column${i}`]}
          </div>
        );
    }



    return(
       <div style={{ display: 'flex', width:'100%' }}>
            {result}
        </div>
    );
}

AmenitiesList.propTypes = {
    columns: PropTypes.number.isRequired,
    gap: PropTypes.number.isRequired,
    children: PropTypes.arrayOf(PropTypes.element),
};
AmenitiesList.defaultProps = {
    columns: 2,
    gap: 20,
};


export default AmenitiesList;
